import React from 'react';

const Hero = () => {
  return (
    <section id="hero" className="relative w-full">
      <div className="relative h-[70vh] sm:h-[75vh] lg:h-[70vh] w-full overflow-hidden">
        <img
          src="/images/hero10.jpg"
          alt="Découpe laser métal"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        {/* Gradient overlay for professional contrast */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-transparent" />

        {/* Content */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
            <h1 className="text-sm md:text-base font-light tracking-[0.3em] mb-6 uppercase">Laser Metal Design</h1>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold mb-8 leading-tight">
              DÉCOUPE LASER MÉTAL DE PRÉCISION pour la TECHNIQUE et le DESIGN à TUNIS
            </h2>
            <a
              href="#devis"
              className="inline-flex items-center px-6 py-3 rounded-md bg-gray-900 text-white hover:bg-black font-semibold tracking-wide uppercase transition-colors duration-300"
            >
              Demande de devis
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;


